<template>
  <div class="allbox">
    <div style="margin-bottom:20px;">
      <div class="condition">
        <el-input
          v-model="query.sub_uc_id"
          class="inptw"
          placeholder="请输入子账号id"
        />
        <el-input
          v-model="query.sub_uc_name"
          class="inptw"
          placeholder="请输入子账号名称"
        />
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="queryAccountList"
        >搜索</el-button>
        <el-button
          type="success"
          icon="el-icon-setting"
          @click="accountOauthUrl"
        >授权</el-button>
      </div>
    </div>
    <el-table
      :data="baidudataList"
      highlight-current-row
      border
      style="width: 100%"
    >
      <el-table-column
        prop="id"
        label="id"
      />
      <el-table-column
        prop="user_id"
        label="主账号id"
      />
      <el-table-column
        prop="cid"
        label="账户主体id"
      />
      <el-table-column
        prop="liceName"
        label="账户主体名称"
      />
      <el-table-column
        prop="sub_uc_id"
        label="子账号id"
      />
      <el-table-column
        prop="sub_uc_name"
        label="子账号名称"
      />
      <el-table-column
        prop="userStat"
        label="账户状态"
      />
      <el-table-column
        prop="balance"
        label="账户余额"
      />
      <el-table-column
        prop="budget"
        label="账户预算"
      />
      <el-table-column
        prop="created_at"
        label="创建时间"
      />
    </el-table>
    <pagination-right
      :current-page="query.page"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>

import { AccountOauthUrl, getBaiduADAccountList } from '@/api/baiduAD'
import PaginationRight from '@/components/PaginationRight/index.vue'

export default {
  components: { PaginationRight },
  data() {
    return {
      baidudataList: [],
      total: 0,
      query: {
        sub_uc_name: null,
        page: 1,
        pageSize: 10,
        sub_uc_id: null
      }
    }
  },
  created() {
    this.list()
  },
  methods: {
    list() {
      getBaiduADAccountList(this.query).then(res => {
        this.baidudataList = res.data.list
        console.log(this.baidudataList)
        this.total = res.data.total
      })
    },
    fetchPageSize(e) {
      this.query.pageSize = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    accountOauthUrl() {
      AccountOauthUrl().then(res => {
        window.open(res.data.oauth_url)
      })
    },
    queryAccountList() {
      getBaiduADAccountList(this.query).then(res => {
        this.baidudataList = res.data.list
        console.log(this.baidudataList)
        this.total = res.data.total
        this.$message({
          message: '查询成功',
          type: 'success'
        })
      })
    }
  }
}
</script>

<style scoped>
.allbox {
  padding: 30px;
}
.tag_box{
  margin: 0 10px 10px 0px;
}
.inptw {
  width: 250px;
}
.condition >* {
  margin-right: 10px;
}
</style>
